import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Block from '../Block'
import { CalculatorContext } from '../Context/CalculatorContext'
import { PROXY_REGENERATION_TITLE } from '../../strings/titles'
import { calculateProxyRegenerationCost } from '../../model/calculator/calculator'
import RemoveBlockButton from '../Calculator/RemoveBlockButton'
import Slider from '../Slider'
import sliders from '../../templates/sliders'

const ProxyRegenerationBlock = ({ cost, setCost, setShowBlock }) => {
    const [proxyRegeneration, setProxyRegeneration] = useState(0)
    const { currency } = useContext(CalculatorContext)

    useEffect(() => {
        setCost(calculateProxyRegenerationCost(proxyRegeneration))
    }, [proxyRegeneration, setCost, currency])

    const handleRemoveBlock = () => {
        setCost(0)
        setShowBlock(false)
    }

    return (
        <Block
            currency={currency}
            cost={cost}
            title={PROXY_REGENERATION_TITLE}
            startOpen={true}
        >
            <RemoveBlockButton onClick={handleRemoveBlock} />
            <Slider
                value={proxyRegeneration}
                onChange={setProxyRegeneration}
                {...sliders.proxyRegeneration}
            />
        </Block>
    )
}

ProxyRegenerationBlock.propTypes = {
    cost: PropTypes.number,
    setCost: PropTypes.func,
    setShowBlock: PropTypes.func
}

export default ProxyRegenerationBlock
